<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Add quick, dynamic tab functionality to transition through panes of local content, even via dropdown menus. <strong>Nested tabs are not supported.</strong></p>
  <p>The easiest way to add the tabs component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">tabs</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
